import {useCallback} from 'react';
import {useStore} from 'react-redux';
import {navigateToRoute, useCurrentRoute} from '~/CreateFabricInvitation/navigation';
import {useEmailPreview} from '~/common/fabric/Card/components/EventPreview/hooks/useEmailPreview';
import {usePreviewInvitation} from '~/common/fabric/Card/components/EventPreview/hooks/usePreviewInvitation';
import {PreviewSelectContainer} from '~/common/fabric/Card/components/EventPreview/mobile/PreviewSelectCreateFlow';
import {isInCreateFlowNavABTest} from '~/common/fabric/experiments';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {ClickOutLineIcon} from '~library/svg/ClickOutLineIcon';
import {EditLineIcon} from '~library/svg/EditLineIcon';
import {EyeIcon} from '~library/svg/EyeIcon';

export const PreviewButtons = ({onSave, eventId, isDesktop}) => {
  const store = useStore();
  const currentRoute = useCurrentRoute();

  const {sendEmailPreview} = useEmailPreview({eventId});
  const {onPreviewInvitationClick} = usePreviewInvitation({eventId});
  const isInNavABTest = isInCreateFlowNavABTest();

  const onClickHandler = useCallback(
    (callback) => async () => {
      const savePromise = onSave();
      callback(savePromise);
      await savePromise;
    },
    [onSave]
  );

  const onClickHandlerMobile = useCallback(
    async (value) => {
      const savePromise = onSave();
      if (value === 'email') {
        sendEmailPreview();
      } else {
        onPreviewInvitationClick(savePromise);
      }
      await savePromise;
    },
    [onSave, sendEmailPreview, onPreviewInvitationClick]
  );

  const handleEditInvitationClick = useCallback(() => {
    navigateToRoute('preview', store);
  }, [store]);

  const inDesktopReview = currentRoute.path === 'review' && isDesktop;

  if (!inDesktopReview && currentRoute.path !== 'preview') return null;

  if (!isDesktop || isInNavABTest) {
    return (
      <PreviewSelectContainer
        onChange={onClickHandlerMobile}
        isInNavABTest={isInNavABTest}
        style={{container: {width: 'fit-content', maxHeight: '2rem'}}}
      />
    );
  }

  return (
    <div className="fabric-header__preview-buttons">
      {inDesktopReview && (
        <Button
          variant="secondary"
          data-qa-id="edit-invitation-btn"
          onClick={handleEditInvitationClick}
          disableProcessing
        >
          <EditLineIcon className="review-content__email-preview-btn-icon" ratio={0.75} />
          <Typography variant="paragraph2">Edit Invitation</Typography>
        </Button>
      )}
      <Button
        variant="secondary"
        data-qa-id="preview-as-guest-btn"
        onClick={onClickHandler(onPreviewInvitationClick)}
        disableProcessing
      >
        <EyeIcon className="review-content__preview-btn-icon" ratio={0.75} />
        <Typography variant="paragraph2">Preview as guest</Typography>
      </Button>
      <Button
        variant="secondary"
        data-qa-id="email-preview-btn"
        onClick={onClickHandler(sendEmailPreview)}
        disableProcessing
      >
        <ClickOutLineIcon className="review-content__email-preview-btn-icon" ratio={0.75} />
        <Typography variant="paragraph2">Email me a preview</Typography>
      </Button>
    </div>
  );
};
